import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  user: { userId: string; role?: string; csrfToken?: string } | null;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginUser: (
      state,
      action: PayloadAction<{
        userId: string;
        role?: string;
        csrfToken?: string;
      }>,
    ) => {
      state.user = {
        userId: action.payload.userId,
        role: action.payload.role,
        csrfToken: action.payload.csrfToken,
      };
    },
    logoutUser: (state) => {
      state.user = null;
    },
  },
});

export const { loginUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;
